import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ApiService from "../../../../services/api";
import "../css/direction_artistic_components.css";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { AuthContext } from "../../../../services/auth";

const ArtisticDirectionComponents = () => {
  const { isEnglish } = useContext(AuthContext);
  const [lable, setLable] = useState({});
  const [category, setCategory] = useState({});
  const [Loading, setLoading] = useState(true);
  const fetchNewsCaterory = async () => {
    try {
      const Lable = await ApiService.getLable();
      const ArtisticCategory = await ApiService.getCategories();
      setLable(Lable);
      setCategory(ArtisticCategory.filter((select) => select.type === "lable"));
      setLoading(false);
    } catch (error) {
      setLoading(true);
    }
  };

  useEffect(() => {
    fetchNewsCaterory();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="padding_custom ">
      <Container className="">
        <Container className="">
          {lable
            .filter((filters) => filters.category === "description")
            .map((data) => {
              return (
                <Container key={data.id}>
                  <h2 className="section-title mt-5">
                    {isEnglish ? "ARTISTIC DIRECTION" : "DIREZIONE ARTISTICA"}
                    <div className="border-custom mt-3 "></div>
                  </h2>
                  <h6 className="mt-4 text-center section-text">
                    {isEnglish
                      ? parse(data.description_eng)
                      : parse(data.description)}
                  </h6>
                </Container>
              );
            })}
        </Container>
        <h3 className="text-center w-100 section-title mt-5 pt-5">
          {isEnglish ? "LABELS" : "ETICHETTE"}
        </h3>
        <div className="border-custom mt-3 "></div>
        <Row className="w-100 my-5 mx-0">
          {category.map(({ id, name }) => {
            return (
              <Col
                className="p-2  d-flex align-content-center justify-content-center "
                key={id}
              >
                {lable
                  .filter((filters) => filters.category === name)
                  .map((data) => {
                    return (
                      <Container
                        fluid
                        className="p-0 m-0 container_img_direction my-3"
                        key={data.id}
                      >
                        <Link to={data.category === 'Aulicus Classics' ? "https://www.aulicusclassics.com/general-catalog/aulicus-classics" : "/art-direction/" + data.category} target={data.category === 'Aulicus Classics' ? "_blank" : ""}>
                          <img
                            src={data.url}
                            alt=""
                            className="w-100 h-100 object-fit-cover img-focus-custom"
                          ></img>
                        </Link>
                      </Container>
                    );
                  })}
              </Col>
            );
          })}
        </Row>
      </Container>
    </Container>
  );
};
export default ArtisticDirectionComponents;
